<template>
  <dropdown
    :dropdown-items="scores"
    :selected-name="getSelectedScore()"
    :placeholder="'Select score'"
    :on-select="handleSelectChange"
  />
</template>
<script>
export default {
  props: {
    selectedScore: {
      type: Number,
    },
    onSelect: {
      type: Function,
    },
  },
  data() {
    return {
      scores: [
        { name: "Good", value: 1 },
        { name: "Better", value: 2 },
        { name: "Best", value: 3 },
      ],
    };
  },
  methods: {
    getSelectedScore,
    handleSelectChange,
  },
};

function getSelectedScore() {
  if (this.selectedScore) {
    return this.scores.find((item) => item.value === this.selectedScore)?.name?.toUpperCase();
  }
  return null;
}

function handleSelectChange(item) {
  this.onSelect(item);
}
</script>
